/* eslint-disable camelcase */

/**
 * An Event
 * @param {string} external_id - External_id
 * @param {string} id - Event ID
 * @param {string} name - Name
 * @returns {Class} - Event instance
 */
class Event {
	constructor({
		id,
		name,
		start_date,
		publication_status
	} = {}) {
		this._id = id;
		this._name = name;
		this._date = start_date;
		this._status = publication_status;
	}

	getId() {
		return this._id;
	}

	getKey() {
		return String(this._id);
	}

	toString() {
		return this._name;
	}

	getName() {
		return this._name;
	}

	getStatus() {
		return this._status;
	}

	getStatusColor() {
		switch (this._status) {
		case "closed":
			return "red";
		case "draft":
			return "orange";
		default:
			return "green";
		}
	}

	getDate() {
		return this._date;
	}
}

export default Event;
